import { useEffect, useRef, useState } from 'react'
import { Button } from '../components/Elements'
import DownloadExcel from '../components/InsertCustomerWithExcel/downloadCustomerExampleExcel/DownloadExcel'
import UploadCustomerExcel from '../components/InsertCustomerWithExcel/uploadCustomerExcel/UploadCustomerExcel'
import ViewExcelTable from '../components/InsertCustomerWithExcel/uploadCustomerExcel/ViewExcelTable'
import { ApiResponseType } from '../../common/api/apiHelper'
import { Form, Formik, FormikProps } from 'formik'
import FormObserver from '../components/FormElements/FormObserver'
import { FormCheckbox, FormSelector } from '../components/FormElements'
import { insertCustomerWithExcelUserNameOptions } from '../../constants/options/insertCustomerWithExcelUserNameOptions'
import { insertCustomerWithPasswordOptions } from '../../constants/options/insertCustomerWithExcelPasswordOptions'
import commonNetwork from '../../common/api/commonNetwork'
import { toast } from 'react-toastify'
import { insertCustomerWithExcel } from '../../common/validators/insertCustomerWithExcel'
import { errorMessages } from '../../constants/messages/errorMessages'
import { successMessages } from '../../constants/messages/successMessages'
import PageTitle from '../components/PageTitle'
import { pageTitleTexts } from '../../constants/texts/pageTitleTexts'
import { useRecoilValue } from 'recoil'
import { tenantState } from '../../store/recoil/tenant/atoms'
import UploadCustomerExcelModal, { UploadCustomerExcelModalHandles } from '../components/InsertCustomerWithExcel/uploadCustomerExcel/UploadCustomerExcelModal'
import { getWebCustomerList } from '../../store/slices/webCustomersSlice'
import { useDispatch } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { usePermissionCheck } from '../../hooks/usePermissionCheck'
import { UserOperationTypes } from '../../common/types/AuthorizationProps'

interface InsertCustomerWithExcelProp {
}

type InsertCustomerWithExcelType = {
  isUserCreate: boolean,
  username: string,
  password: string
}

const InsertCustomerWithExcel: React.FC<InsertCustomerWithExcelProp> = () => {
  usePermissionCheck(UserOperationTypes["Müşteri Listesi"], "Müşteri İşlemleri izni yok");
  const { firmInformations } = useRecoilValue(tenantState);

  const formRef = useRef<FormikProps<InsertCustomerWithExcelType>>(null);
  const resultModalRef = useRef<UploadCustomerExcelModalHandles | any>(null);

  const [formValues, setFormValues] = useState<InsertCustomerWithExcelType>({
    isUserCreate: false,
    username: "",
    password: ""
  });
  const [excelData, setExcelData] = useState<any[] | null>(null);
  const [postLoading, setPostLoading] = useState(false);
  const [isUserCreatePermission, setIsUserCreatePermission] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [disableSave, setDisableSave] = useState<boolean>(true);
  const [uploadExcelModalVisible, setUploadExcelModalVisible] = useState<boolean>(false);

  const thunkdispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    checkIsUserCreate();
  }, [])

  const handleShowData = (data: any[]) => {
    setExcelData(data);
  };

  const onUpdate = (value: InsertCustomerWithExcelType) => {
    setFormValues({ ...formValues, ...value })
  }

  const onSubmit = async () => {
    if (!excelData) return;

    const customerList = excelData.map((data: any) => (
      {
      customercode: data.customercode,
      customername: data.customername,
      taxcode: data.taxcode?.toString().length === 10 ? data.taxcode : "",
      tccode: data.taxcode?.toString().length === 11 && !data.tccode ? data.taxcode : data.tccode || "",
      taxoffice: data.taxoffice,
      country: data.country,
      city: data.city,
      district: data.district,
      postalcode: data.postalcode,
      address: data.address,
      phone: data.phone,
      mobile: data.mobile,
      email: data.email
    }));

    const parameters = {
      customerList,
      isUserCreate: formValues.isUserCreate,
      userName: formValues.username,
      password: formValues.password
    }

    setPostLoading(true);
    let result: any;

    try {
      result = await commonNetwork.post("/customer/impor-excel", parameters);

      if (result.isSuccess) {
        toast.success(successMessages.listSaved);
        setUploadExcelModalVisible(true);
        resultModalRef.current.getResult(result);
        thunkdispatch(getWebCustomerList(parameters));
      } else {
        toast.error(result.errorMessage);
      }
    } catch (error) {
      toast.error(errorMessages.anError + " : " + error);
    } finally {
      setPostLoading(false);
    }
  }

  async function checkIsUserCreate() {

    let result: ApiResponseType;
    result = await commonNetwork.get(`/tenant/${firmInformations.firmPath}`);

    if (result.isSuccess) {
      if (result.data.isB2bPackage) {
        setIsUserCreatePermission(true);
      } else {
        setIsUserCreatePermission(false);
      }
    } else {
      toast.error("Kullanıcı oluştur yetkisi okunurken bir hata meydana geldi.");
    }
  }

  const handleLoading = (data: boolean) => {
    setLoading(data);
  }

  const handleDisableSave = (value: boolean) => {
    setDisableSave(value);
  }

  return (
    <div className='w-full'>
      <PageTitle title={pageTitleTexts.insertCustomerWithExcel} />

      <div className="px-4 py-2 flex flex-col justify-start space-y-2">
        <div className="flex flex-row items-center">
          <img src={"/icons/musteri-listesi-dark.svg"} className="h-6 w-6 black" />
          <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
            Excel ile Müşteri Aktar
          </span>
        </div>
      </div>

      <div className='mx-4 px-4 py-2 bg-white shadow-md mb-4 pb-4 mt-1 rounded-md'>
        <div className='px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-4'>
          <div className='mt-3'>
            <h1 className='font-bold text-contrast-90'>Örnek Excel Dosyasına Göz Atın</h1>
            <span className='text-contrast-50 text-md'>
              Müşteri bilgilerinizi örnek excel dosyasına göre doldurarak yükleyebilirsiniz.
            </span>
          </div>

          <div className='w-full col-span-2'>
            <div className='grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2'>
              <div className='mt-6'>
                <DownloadExcel />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Formik
        innerRef={formRef}
        initialValues={formValues}
        validationSchema={formValues.isUserCreate ? insertCustomerWithExcel : ""}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ }) => (
          <Form>
            <FormObserver
              watch={(val: any) => {
                onUpdate(val);
              }}
            />
            <div className={isUserCreatePermission ? 'mx-4 px-4 py-2 bg-white shadow-md mb-4 pb-4 mt-6 rounded-md' : "hidden"}>
              <div className='px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-4'>
                <div className='mt-3'>
                  <h1 className='font-bold text-contrast-90'>Kullanıcı Oluşturulsun Mu?</h1>
                  <span className='text-contrast-50 text-md'>
                    Seçim yapınız.
                  </span>
                </div>
                <div className='mt-4'>
                  <FormCheckbox
                    key={1}
                    label={"Evet"}
                    name="isUserCreate"
                    type="checkbox"
                    onChange={() => { }}
                  />
                </div>
              </div>
              <div className={!formValues.isUserCreate ? "hidden" : "px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-4"}>
                <div className='mt-3'>
                  <h1 className="font-bold text-contrast-90">Yeni Kullanıcı için Kullanılacak Alanlar</h1>
                  <span className="text-contrast-50 text-md">
                    Kullanıcı ve parola seçimlerini yapınız.
                  </span>
                </div>
                <div className='mt-3'>
                  <FormSelector
                    options={insertCustomerWithExcelUserNameOptions}
                    name="username"
                    placeholder="Kullanıcı adı seç"
                    label="Kullanıcı Adı Seçilecek Alan"
                    isClearable
                  />
                </div>
                <div className='mt-3'>
                  <FormSelector
                    options={insertCustomerWithPasswordOptions}
                    name="password"
                    placeholder="Parola seç"
                    label="Parola Seçilecek Alan"
                    isClearable
                  />
                </div>
              </div>
            </div>

            <div className='mx-4 px-4 py-2 bg-white shadow-md mb-4 pb-4 mt-6 rounded-md'>
              <div className='px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-4'>
                <div className='mt-3'>
                  <h1 className='font-bold text-contrast-90'>Excel ile Müşteri Yükle</h1>
                  <span className='text-contrast-50 text-md'>
                    Müşteri bilgilerinizin yer aldığı dosyayı seçiniz.
                  </span>
                </div>

                <div className='w-full col-span-2'>
                  <div className='grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2'>
                    <div className='mt-7'>
                      <UploadCustomerExcel onDataUpload={handleShowData} loading={handleLoading} />
                    </div>
                    <div className='mt-6'>
                      <Button
                        size="xs"
                        hover="primary"
                        color="primary"
                        callback={() => { }}
                        loading={postLoading}
                      >
                        <img src="/icons/file-upload.svg" alt="exampleExcelFile" />
                        <span className='ml-3 mr-3'>Müşterileri Kaydet</span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>

      <div className="">
        <ViewExcelTable data={excelData} loading={loading} disableSave={handleDisableSave} />
      </div>
      <UploadCustomerExcelModal ref={resultModalRef} statusModalVisible={uploadExcelModalVisible} setStatusModalVisible={setUploadExcelModalVisible} />
    </div>

  )
}

export default InsertCustomerWithExcel